<template>
  <div class="box">
    <div class="top">
      <span class="fl"><i class="sz szlingdangbeifen fs13 mr5"></i>消息提醒</span>
      <el-switch class="mySwitch pr t1"
                 v-model="showNoti"
                 active-text="消息弹窗"
                 active-color="#FF8F48"
                 :active-value="true"
                 :inactive-value="false">
      </el-switch>
      <el-switch class="mySwitch ml15 pr t1"
                 v-model="audioPlay"
                 active-text="声音提醒"
                 active-color="#FF8F48"
                 :active-value="true"
                 :inactive-value="false">
      </el-switch>
      <el-button class="fr w80"
                 size="mini"
                 @click="delRead">删除已读</el-button>
      <el-button class="fr mr10"
                 size="mini"
                 @click="readAll">全部标为已读</el-button>
    </div>
    <div class="left">
      <ul class="leftBox">
        <li v-for="(x ,index) in list"
            :key="x.id"
            :class="[{'active':index==currentIndex,'read':x.ck}]"
            @click="select(index)">
          <i class=""></i>
          <span>{{x.title}}</span>
        </li>
      </ul>
    </div>
    <div class="right">
      <div class="msg"
           v-if="currentIndex>=0">
        <div class="title">{{list[currentIndex].title}}</div>
        <pre>{{list[currentIndex].msg}}</pre>
        <div class="btn">
          <el-button class="fl w90"
                     size="mini"
                     type="primary">立即处理</el-button>
          <el-button class="fr w90"
                     size="mini"
                     type="default"
                     @click="del">删除</el-button>
        </div>
      </div>
      <div v-else>
        <img src="@/assets/none.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "msgCenter",
  computed: {
    list () {
      return this.$store.state.msg.list;
    },
    currentIndex () {
      return this.$store.state.msg.currentIndex;
    },
    showNoti: {
      get () {
        return this.$store.getters['msg/showNoti']
        // return this.$store.state.msg.showNoti;
      },
      set (show) {
        this.$store.commit("msg/setShowNoti", show);
      },
    },
    audioPlay: {
      get () {
        return this.$store.getters['msg/audioPlay']
      },
      set (show) {
        this.$store.commit("msg/setAudioPlay", show);
      },
    }
  },
  methods: {
    select (index) {
      this.$store.commit("msg/select", index);
    },
    del () {
      this.$store.commit("msg/del");
    },
    delRead () {
      this.$store.commit("msg/delRead");
    },
    readAll () {
      this.$store.commit("msg/readAll");
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  color: #333;
  position: absolute;
  z-index: 9;
  width: 550px;
  height: 350px;
  background-color: white;
  right: 15px;
  top: 60px;
  box-shadow: 0 5px 20px 0px rgba(47, 49, 79, 0.3);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  .top {
    height: 40px;
    width: 100%;
    span {
      font-size: 15px;
      font-weight: bold;
      color: #2f314f;
      line-height: 28px;
    }
  }
  .left {
    float: left;
    width: 150px;
    height: 290px;
    overflow: hidden;
    background-color: #fafbfc;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    .leftBox {
      width: calc(100% + 12px);
      height: 290px;
      overflow-y: scroll;
      padding: 3px 0;
      li {
        text-align: left;
        padding-left: 10px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        span {
          margin-left: 3px;
        }
        i {
          display: inline-block;
          width: 7px;
          height: 7px;
          background-color: #f7b288;
          border-radius: 7px;
        }
      }
      li:hover,
      li.active {
        background-color: #eeeff4;
        cursor: pointer;
      }
      li.read i {
        background-color: transparent;
      }
    }
  }
  .right {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    background-color: #fafbfc;
    float: left;
    width: 380px;
    height: 290px;
    padding: 10px;
    .title {
      font-weight: bold;
      font-size: 14px;
      text-align: left;
      height: 30px;
    }
    pre {
      text-align: left;
      font-size: 13px;
      white-space: pre-wrap;
      background: #f7f7f9;
      border: 1px solid #eee;
      padding: 10px;
      border-radius: 5px;
      line-height: 20px;
    }
    .btn {
      padding-top: 10px;
    }
  }
  img {
    width: 100px;
    height: 100px;
    position: relative;
    top: 80px;
  }
}
</style>

<style lang="scss">
.mySwitch {
  span {
    font-size: 13px !important;
  }
}
</style>